import { BASE_URL } from './api'
import { PATHS } from './endpoints'
import { FileResponseSchema, FileDeleteSchema } from '@leangap/types'
import { z } from 'zod'
import { ApiError, handleNonOkResponse } from './apiError'

export async function uploadAidFile({
	file,
	email,
	fullName,
	userId,
}: {
	file: File
	email?: string
	fullName?: string
	userId?: string
}) {
	const formData = new FormData()
	formData.append('email', email ?? '')
	if (fullName) formData.append('fullName', fullName)
	if (userId) formData.append('userId', userId)
	formData.append('file', file)

	const res = await fetch(`${BASE_URL}${PATHS.file}`, {
		method: 'POST',
		body: formData,
		credentials: 'include',
	})
	if (!res.ok) {
		await handleNonOkResponse(res, 'Upload failed')
	}
	const json = await res.json()
	// validate runtime shape
	const parsed = FileResponseSchema.safeParse(json)
	if (!parsed.success) {
		// include zod error tree in details for caller/telemetry but throw ApiError
		const details = z.treeifyError(parsed.error)
		throw new ApiError(null, 'Invalid file upload response', 'invalid_response', details)
	}
	return parsed.data
}

export async function deleteAidFile(payload: { email?: string; file_id?: string }) {
	const res = await fetch(`${BASE_URL}${PATHS.file}`, {
		method: 'DELETE',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(payload),
		credentials: 'include',
	})
	if (!res.ok) {
		await handleNonOkResponse(res, 'Delete failed')
	}
	const json = await res.json()
	const parsed = FileDeleteSchema.safeParse(json)
	if (!parsed.success) {
		const details = z.treeifyError(parsed.error)
		throw new ApiError(null, 'Invalid file delete response', 'invalid_response', details)
	}
	return parsed.data
}
